module.exports = "<div class=\"state-pending\" [class.relative]=\"relativeVersion\">\r\n    <span></span><span></span><span></span>\r\n</div>\r\n"